module.exports = __webpack_public_path__ + "static/media/home_performance_cover.7fbafc0b.jpg";